import { render } from "./Top10Country.vue?vue&type=template&id=e5e0419c&scoped=true&ts=true"
import script from "./Top10Country.vue?vue&type=script&lang=ts"
export * from "./Top10Country.vue?vue&type=script&lang=ts"

import "./Top10Country.vue?vue&type=style&index=0&id=e5e0419c&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5e0419c"]])

export default __exports__